import React from 'react';
import { X, Check } from 'lucide-react';
export function YoutubeVsSystem() {
  return <section className="py-20 bg-[#FDFCF8]" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-12" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-161">
            If You Learned Resin From YouTube...
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-162">
            Random tutorials often miss the critical science of curing, leaving
            you with wasted materials.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-163">
          {/* The Hard Way */}
          <div className="bg-white rounded-2xl shadow-sm border border-stone-100 overflow-hidden relative group" data-id="element-164">
            <div className="absolute top-4 left-4 bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-bold flex items-center gap-1 z-10" data-id="element-165">
              <X className="w-4 h-4" data-id="element-166" /> The Guesswork Way
            </div>
            <div className="h-64 bg-stone-200 relative" data-id="element-167">
              <img src="https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=2071&auto=format&fit=crop" alt="Frustrated person with messy craft table" className="w-full h-full object-cover grayscale opacity-80" data-id="element-168" />
              <div className="absolute inset-0 bg-red-900/10 mix-blend-multiply" data-id="element-169" />
            </div>
            <div className="p-8" data-id="element-170">
              <ul className="space-y-3" data-id="element-171">
                <li className="flex items-start gap-3 text-stone-600" data-id="element-172">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-173" />
                  <span data-id="element-174">Conflicting advice from different creators</span>
                </li>
                <li className="flex items-start gap-3 text-stone-600" data-id="element-175">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-176" />
                  <span data-id="element-177">
                    No explanation of <i data-id="element-178">why</i> things go wrong
                  </span>
                </li>
                <li className="flex items-start gap-3 text-stone-600" data-id="element-179">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-180" />
                  <span data-id="element-181">Wasting expensive resin on trial and error</span>
                </li>
              </ul>
            </div>
          </div>

          {/* The System Way */}
          <div className="bg-white rounded-2xl shadow-xl border-2 border-teal-100 overflow-hidden relative transform md:-translate-y-4" data-id="element-182">
            <div className="absolute top-4 left-4 bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-bold flex items-center gap-1 z-10" data-id="element-183">
              <Check className="w-4 h-4" data-id="element-184" /> The Error-Free System
            </div>
            <div className="h-64 bg-teal-50 relative" data-id="element-185">
              <img src="https://images.unsplash.com/photo-1664575602554-2087b04935a5?q=80&w=2070&auto=format&fit=crop" alt="Organized workspace with checklist" className="w-full h-full object-cover" data-id="element-186" />
            </div>
            <div className="p-8" data-id="element-187">
              <ul className="space-y-3" data-id="element-188">
                <li className="flex items-start gap-3 text-stone-700 font-medium" data-id="element-189">
                  <Check className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-190" />
                  <span data-id="element-191">Proven, step-by-step scientific method</span>
                </li>
                <li className="flex items-start gap-3 text-stone-700 font-medium" data-id="element-192">
                  <Check className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-193" />
                  <span data-id="element-194">Diagnostic checklists to prevent errors</span>
                </li>
                <li className="flex items-start gap-3 text-stone-700 font-medium" data-id="element-195">
                  <Check className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-196" />
                  <span data-id="element-197">Predictable, professional results every time</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}